import React from 'react';
import { object } from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import App from '../../../components/App';
import { LINKS } from '../../../components/constants';
import { AppProvider } from '../../../components/contexts/AppContext';

const CareersPage = ({ ...props }) => (
    <AppProvider value={props}>
        <Router basename={LINKS.BASE_URL}>
            <App {...props} />
        </Router>
    </AppProvider>
);

CareersPage.propTypes = {
    context: object,
    data: object,
};

export default CareersPage;
